import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[festival-slug]/[locale]/(rest)/films/components/PaginatedFilmList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BlogCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/ArrowLink.tsx");
